import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};

export const UserDetailSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    userHandler: (state, action) => {

      state.value = action.payload;
    },
    clearUserDetails: (state) => {
      state.value = null;
    },
  },
});

export const { userHandler, clearUserDetails } = UserDetailSlice.actions;

export default UserDetailSlice.reducer;
